module.exports = __webpack_public_path__ + "assets/img/title-45a70c7f.png";